import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import OceanWaveSection from "@/components/OceanWaveSection";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import AmrutAuraPage from "@/pages/AmrutAuraPage";
import AmrutSeafoodPage from "@/pages/AmrutSeafoodPage";
import AmrutInnPage from "@/pages/AmrutInnPage";
import AmrutBakeryPage from "@/pages/AmrutBakeryPage";
import AmrutJewellersPage from "@/pages/AmrutJewellersPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/amrut-aura" element={<AmrutAuraPage />} />
          <Route path="/amrut-seafood" element={<AmrutSeafoodPage />} />
          <Route path="/amrut-inn" element={<AmrutInnPage />} />
          <Route path="/amrut-delight" element={<AmrutBakeryPage />} />
          <Route path="/amrut-jewellers" element={<AmrutJewellersPage />} />
        </Routes>
      </main>
      <OceanWaveSection />
      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
